import { Map } from 'immutable';

export const DefaultServices = Map({
    'pension-options': Map({
        id: 393,
        name: 'Understanding my <span class="semi-bold">pension options</span>',
        label: 'Understanding my pension options',
        title: 'Find the best Financial Adviser to help <span class="line">with understanding your pension options</span>',
        description: 'who can help with pension options',
    }),
    'finances-review': Map({
        id: 397,
        name: '<span class="semi-bold">Reviewing</span> my finances',
        label: 'Reviewing my finances',
        title: 'Find the best Financial Adviser to help <span class="line">with reviewing your finances</span>',
        description: 'who can review your finances',
    }),
    'pension-transfer': Map({
        id: 393,
        name: 'Transferring <span class="semi-bold">pensions</span>',
        label: 'Transferring pensions',
        title: 'Find the best Financial Adviser to help <span class="line">with your pension transfer options</span>',
        description: 'who can help with your pension transfer',
    }),
    'inheritance-investment': Map({
        id: 397,
        name: '<span class="semi-bold">Investing a sum</span> of money I’ve received',
        label: "Investing a sum of money I've received",
        title: 'Find the best Financial Adviser to help <span class="line">with investing your money well</span>',
        description: 'who can help with your investments',
    }),
    mortgage: Map({
        id: 392,
        name: '<span class="semi-bold">Buying a house</span> or <span class="semi-bold">remortgaging</span>',
        label: 'Finding the best mortgage advice',
        title: 'Find the best Adviser to help <span class="line">with mortgage advice</span>',
        description: 'to help with mortgage advice',
    }),
    'investment-and-pension': Map({
        id: 397,
        name: '<span class="semi-bold">Starting a pension</span> or investment',
        label: 'Starting a pension or investment',
        title: 'Find the best Financial Adviser to help <span class="line">with starting a pension or investment</span>',
        description: 'who can help start a pension or investment',
    }),
});
